import React from "react";
import { useDispatch } from "react-redux";
import { XCircle } from "react-feather";
import { actionCreators as participantsActions } from "../../../state/ducks/participants";

import ParticipantActionButton from "./ParticipantActionButton";

function Reconnect({ participantId, ...props }) {
  const dispatch = useDispatch();
  const label = "Remove participant";

  return (
    <ParticipantActionButton
      icon={XCircle}
      label={label}
      onClick={() =>
        dispatch(participantsActions.removeParticipant(participantId))
      }
      {...props}
    />
  );
}

export default Reconnect;
